import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Nikhil', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my website', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: 'Nikhil M Sawant',
  subtitle: 'I\'m a Web Developer',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'Nikhil.jpeg',
  paragraphOne: 'I\'m in third year of my engineering course. I have been practicing web development since last 12 months. I have did internship for 3 months from Nov 2019 onwards to Jan 2020 at Team Mitra Solutions where I developed my first web project.Now I am focusing on React, Python for Data Analysis and problem solving skills on Hackerrank. Also I am 3 star coder on hackerrank.',
  paragraphTwo: ' I wish to start contribute towards open source community so that I can get experience and explore new Technologies.',
  paragraphThree: 'I have learned and coded in Python, C /C++, PHP and JavaScript languages previously.',
  resume: '', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'blog_it.png',
    title: 'Blog{IT}',
    info: 'This is a Online Blogging website where user can post their articles and update on the community page regularly about their blogs, also can comment on other user’s blogs and posts. This helps in growing the community more and more, resulting in finding new persons with same ideology that will help in improving the blogging network. Also I have added news articles API that helps in updating the user with latest articles giving new ideas to the user for creating new contents for their blog.',
    info2: 'I have used HTML, CSS, PHP, MySQL and JS for developing this site.',
    url: 'http://blogit.epizy.com/Final_trial/',
    repo: 'https://github.com/NickSaw22/TwitterWebApp', // if no repo, the button will not show up
  },
  /*
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'project.jpg',
    title: '',
    info: '',
    info2: '',
    url: '',
    repo: 'https://github.com/cobidev/react-simplefolio', // if no repo, the button will not show up
  },*/
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: 'sawantnikhil122@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/Niksawant22',
    },/*
    {
      id: nanoid(),
      name: 'codepen',
      url: '',
    },*/
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/nikhil-sawant-9a3243194',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/NickSaw22',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
